import React from "react";

const Redtext = ( {data} ) => {
    return(
        <div className="relative flex px-6 py-5 rounded-xl overflow-hidden lg:mt-3 md:mt-6 mt-4 leading-tight" style={{ backgroundColor: data.bg_color }}>
            <div className="absolute left-0 top-0 bottom-0 w-1" style={{ backgroundColor: data.strip_color }}></div>
            <span className="md:text-[16px] text-[14px] font-medium" style={{ color: data.color }}>
               {data.text}
            </span>
        </div>
    );
};
export default Redtext;